import { LoadingStageModel } from '@kts-front/models';
import { action, makeObservable, observable } from 'mobx';

import { IFormField } from 'stores/interfaces/IFormField';

import { FormStore } from '../../form/FormStore';

export type EditFormStoreOptions = {
  onSuccess: (params: { isCreated: boolean; createdClient?: any; createdSubAgent?: any }) => void;
};

/**
 * Если id - не передан, то считаем что происходит создание, а не редактирование
 */
export type EditFormStoreDefaultValues = { id: number | null };

export abstract class EditFormStore<
  DefaultValues extends EditFormStoreDefaultValues,
  FM extends Record<string, IFormField<any>>,
> extends FormStore<FM> {
  readonly loadingStage = new LoadingStageModel();
  protected readonly _options: EditFormStoreOptions;

  id: EditFormStoreDefaultValues['id'] = null;

  constructor(options: EditFormStoreOptions) {
    super();
    this._options = options;

    makeObservable(this, {
      init: action.bound,
      id: observable,
    });
  }

  init({ id }: { id: DefaultValues['id'] }) {
    this.id = id;
  }

  reset(): void {
    super.reset();
    this.loadingStage.reset();
  }

  abstract submit(): Promise<void>;
}
